module.exports = __webpack_public_path__ + "img/condition_1.74861603.png";